import { Component } from '@angular/core';

@Component({
    selector: 'app-separator',
    template: '',
    styleUrls: ['./separator.component.scss'],
    standalone: false
})
export class SeparatorComponent {}
